import script from "./MoreBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./MoreBanner.vue?vue&type=script&setup=true&lang=js"

import "./MoreBanner.vue?vue&type=style&index=0&id=6705c8b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6705c8b6"]])

export default __exports__